import React from 'react';
import { Link } from 'react-router-dom';

import FAWrapper from 'components/vendors/fa-wrapper';
import { Row, Col, Badge, Button } from 'reactstrap';

const InfoCard = (props) => {
	const { html, status, title, line1, line2, line3, className = '', children } = props;


	// Render
	return (
		<div className={'card info ' + className}>
			<div className='card-body'>
				{html && html}
				{status && <Badge color={status} className='sm' pill>{status}</Badge>}
				{title && <h5 className='title'>{title}</h5>}
				{line1 && <h6>{line1}</h6>}
				{line2 && <h6>{line2}</h6>}
				{line3 && <h6>{line3}</h6>}
				{children}
			</div>
		</div>
	)
}

export default InfoCard;
